<template>
  <div class="maintenance-repair">
    <div class="title-en">综合维保子单</div>
    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <el-button @click="openColumnsDialog">表头设置</el-button>
          <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
        </div>
        <el-table :data="tableData" border stripe @selection-change="handleSelectionChange" ref="table"
          v-loading="loading">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column v-for="(column, index) in visibleColumns" :key="index" :prop="column.prop"
            :label="column.label" :width="column.width">
            <template slot-scope="scope">
              <span v-if="
                column.prop === 'CreatedTime' ||
                column.prop === 'EndTime'
              ">{{
                scope.row[column.prop]
                  ? $moment(scope.row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                  : '-'
              }}</span>
              <!-- 上传图片开始列 -->
              <span v-else-if="column.prop === 'UploadStart'" class="upload-cell"
                @click="showUploadDetails(scope.row.UploadStart, '上传图片开始')">
                <el-link type="primary" :underline="false">{{ getUploadDisplayValue(scope.row.UploadStart) }}</el-link>
              </span>
              <!-- 上传图片结束列 -->
              <span v-else-if="column.prop === 'UploadEnd'" class="upload-cell"
                @click="showUploadDetails(scope.row.UploadEnd, '上传图片结束')">
                <el-link type="primary" :underline="false">{{ getUploadDisplayValue(scope.row.UploadEnd) }}</el-link>
              </span>
              <span v-else>{{ scope.row[column.prop] || '-' }}</span>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog title="设置显示项" :visible.sync="showColumnsDialog" :append-to-body="true" width="400px"
          :close-on-click-modal="false" custom-class="columns-dialog" :modal-append-to-body="false"
          :destroy-on-close="true">
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop" class="checkbox-item">
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>

        <!-- 上传图片详情弹窗 -->
        <el-dialog :title="uploadDialogTitle" :visible.sync="uploadDetailDialogVisible" width="80%">
          <div class="upload-detail-content">
            <el-table :data="uploadDetailList" border style="width: 100%" stripe>
              <el-table-column prop="name" label="文件名" width="200">
                <template slot-scope="scope">
                  <el-link type="primary" @click="openImage(scope.row.url)" :underline="false">{{ scope.row.name
                  }}</el-link>
                </template>
              </el-table-column>
              <el-table-column prop="url" label="URL地址" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="url-container">
                    <span class="url-text">{{ scope.row.url }}</span>
                    <el-button size="mini" type="text" class="copy-btn" @click="copyToClipboard(scope.row.url)"
                      icon="el-icon-document-copy" :title="'复制链接'">
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="预览" width="150">
                <template slot-scope="scope">
                  <el-image :src="scope.row.url" :preview-src-list="[scope.row.url]" fit="cover"
                    style="width: 100px; height: 60px; cursor: pointer;" :preview-teleported="true">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="uploadDetailDialogVisible = false">关闭</el-button>
          </span>
        </el-dialog>
        <div class="pagination-container">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getMaintenancefixShow, getMaintenancefixShowAll, getSubmaintenanceTkShow } from '@/api/operation';
import { debounce } from 'lodash';
import * as XLSX from 'xlsx';

export default {
  name: 'subMaintenanceDetail',
  data() {
    return {
      loading: false,
      tableData: [
        // {
        //   AppendReason: '',
        //   CampusName: '贵阳-贵安七星',
        //   ChangeId: '',
        //   CreatedTime: '2025-04-25 17:28:22',
        //   Creator: 'v_xiaychen',
        //   EndTime: '2025-05-19 14:27:58',
        //   EventId: '',
        //   FacilitiesProfessional: '弱电',
        //   FailureReason: '门磁松动',
        //   Id: 107,
        //   IsAppend: '否',
        //   MozuName: '贵阳贵安七星模组21',
        //   PoId: '',
        //   ProblemDesc: '门禁的门磁松动，需要厂家进行紧固',
        //   RepairBusiness: '鸿云',
        //   RepairEngineer: 'lujishi',
        //   RepairLevel: '普通',
        //   RepairScore: '100',
        //   RepairStatus: '维修完成',
        //   TaskName: '',
        //   TicketId: '20250425036752',
        //   TicketTitle: '贵阳贵安七星模组21-门磁脱落',
        //   UpstreamBusiness: '现场反馈',
        //   UpstreamId: '',
        // },
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showColumnsDialog: false,
      selectedColumns: [],
      exportLoading: false,
      debouncedExport: null,
      selectedRows: [],
      defaultSelectedColumns: [
        'TicketId',
        'MainTicketId',
        'StartTime',
        'ProcessTitle',
        'CampusName',
        'MozuName',
        'DeviceUid',
        'DeviceName',
        'DeviceNumber',
        'Professional',
        'DealUser',
        'EndTime',
        'AbnormalCheckCount',
        'StatusLight',
        'MaintainSummary',
        'Confirm',
        'StandardTime',
        'TimeConsuming',
        'DevicetypesName',
        'ApplicationTypeName',
        'TicketStatus',
        'Maintainer',
        'AuditResults',
        'AuditReason',
        'TimeOut',
        'CheckInTime',
        'CheckInStatus',
        'CheckInPlace',
        'MaintenanceType',
        'MaintenanceCycle',
        'PTicketId',
        'PInsId',
        'UploadStart',
        'UploadEnd'
      ],
      columns: [
        { prop: 'TicketId', label: '工单号', width: '150' },
        { prop: 'MainTicketId', label: '主流程工单号', width: '150' },
        { prop: 'StartTime', label: '开始时间', width: '200' },
        { prop: 'ProcessTitle', label: '标题', width: '580' },
        { prop: 'CampusName', label: '园区名称', width: '150' },
        { prop: 'MozuName', label: '模组名称', width: '150' },
        { prop: 'DeviceUid', label: '设备uid', width: '150' },
        { prop: 'DeviceName', label: '设备名称', width: '150' },
        { prop: 'DeviceNumber', label: '设备编号', width: '150' },
        { prop: 'Professional', label: '专业', width: '150' },
        { prop: 'DealUser', label: '负责人', width: '150' },
        { prop: 'EndTime', label: '结束时间', width: '150' },
        { prop: 'AbnormalCheckCount', label: '异常计数', width: '150' },
        { prop: 'StatusLight', label: '状态灯', width: '150' },
        { prop: 'MaintainSummary', label: '维护总结', width: '150' },
        { prop: 'Confirm', label: '确认结单状态', width: '150' },
        { prop: 'StandardTime', label: '标准耗时', width: '150' },
        { prop: 'TimeConsuming', label: '实际耗时', width: '150' },
        { prop: 'DevicetypesName', label: '维护项目名称', width: '150' },
        { prop: 'ApplicationTypeName', label: '应用类型', width: '150' },
        { prop: 'TicketStatus', label: '工单状态', width: '150' },
        { prop: 'Maintainer', label: '服务商', width: '150' },
        { prop: 'AuditResults', label: '工单审核结果', width: '150' },
        { prop: 'AuditReason', label: '审核原因', width: '150' },
        { prop: 'TimeOut', label: '是否超时', width: '150' },
        { prop: 'CheckInTime', label: '打卡时间', width: '150' },
        { prop: 'CheckInStatus', label: '打卡状态', width: '150' },
        { prop: 'CheckInPlace', label: '打卡地点', width: '150' },
        { prop: 'MaintenanceType', label: '维护类型', width: '150' },
        { prop: 'MaintenanceCycle', label: '维护周期', width: '150' },
        { prop: 'PTicketId', label: '问题跟进单号', width: '150' },
        { prop: 'PInsId', label: '问题跟进流程id', width: '150' },
        { prop: 'UploadStart', label: '上传图片开始', width: '150' },
        { prop: 'UploadEnd', label: '上传图片结束', width: '150' }
      ],
      searchForm: {},
      // 新增状态变量用于上传图片详情弹窗
      uploadDetailDialogVisible: false,
      currentUploadContent: '',
      uploadDialogTitle: '',
      uploadDetailList: []
    };
  },
  computed: {
    visibleColumns() {
      return this.columns.filter((column) => this.selectedColumns.includes(column.prop));
    },
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
  created() {
    this.selectedColumns = [...this.defaultSelectedColumns];
    // this.total = 0; // 确保初始化总数为0
    // this.fetchData({
    //   page: this.currentPage,
    //   size: this.pageSize,
    //   start_time: this.searchForm.start_time,
    //   end_time: this.searchForm.end_time,
    //   export: "0"
    // });
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    async fetchData(params = {}) {
      this.total = 0; // 在方法开始时重置总数

      // 添加结束时间的时分秒
      if (params.end_time) {
        params.end_time = this.$moment(params.end_time).format('YYYY-MM-DD 23:59:59');
      }

      // 合并分页参数
      const requestParams = {
        ...this.searchForm,
        page: this.currentPage,
        size: this.pageSize,
        export: "0",
        TicketId: this.searchForm.TicketId || null,
        CampusName: this.searchForm.CampusName || null,
        start_time: this.searchForm.start_time,  // 确保时间参数被包含
        MainTicketId:this.searchForm.MainTicketId || null,
        end_time: this.searchForm.end_time,
        abnormal_situation: this.searchForm.abnormal_situation,  // 添加异常情况参数
        ...params
      };

      // 调试日志
      // console.log('fetchData参数:', requestParams);

      this.searchForm = { ...requestParams };

      this.loading = true;
      try {
        const response = await getSubmaintenanceTkShow(requestParams);

        // 调试：输出完整的响应数据

        // 检查外层code
        if (response.data.code == 200) {
          // 检查内层data结构
          const innerData = response.data.data;
          if (innerData && innerData.code == 200) {
            this.tableData = innerData.data || [];
            this.total = innerData.count || 0;
          } else {
            console.error('内层数据结构错误:', innerData);
            this.tableData = [];
            this.total = 0;
          }
        } else {
          console.error('外层响应错误:', response.data);
          this.tableData = [];
          this.total = 0;
        }
      }
      catch (error) {
        console.error('请求错误:', error);
        let errorMessage = '获取数据失败';
        if (error.response && error.response.status === 422) {
          errorMessage = '请求参数格式不正确，请检查输入';
        }
        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        if (this.selectedRows.length === 0) {
          // 导出全部数据
          this.loading = true;
          const response = await getSubmaintenanceTkShow({
            ...this.searchForm,
            start_time: this.searchForm.start_time,
            end_time: this.searchForm.end_time,
            export: "1",

          });

          if (response.data) {
            this.loading = false;
            const allData = response.data.data.data || [];
            const worksheetData = allData.map((row) => {
              const rowData = {};
              this.visibleColumns.forEach((column) => {
                if (column.prop !== 'operation') {
                  let value = row[column.prop];
                  if (
                    ['CreatedTime', 'EndTime'].includes(
                      column.prop
                    )
                  ) {
                    value = value ? this.$moment(value).format('YYYY-MM-DD HH:mm:ss') : '-';
                  }
                  rowData[column.label] = value || '-';
                }
              });
              return rowData;
            });

            const worksheet = XLSX.utils.json_to_sheet(worksheetData);

            const colWidths = {};
            this.visibleColumns.forEach((column, index) => {
              const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
              colWidths[XLSX.utils.encode_col(index)] = { wch: width };
            });
            worksheet['!cols'] = Object.values(colWidths);

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, '综合维保维修列表');

            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            const filename = `综合维保维修列表_${timestamp}.xlsx`;

            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          }
        } else {
          const worksheetData = this.selectedRows.map((row) => {
            const rowData = {};
            this.visibleColumns.forEach((column) => {
              if (column.prop !== 'operation') {
                let value = row[column.prop];
                if (
                  ['CreatedTime', 'EndTime'].includes(column.prop)
                ) {
                  value = value ? this.$moment(value).format('YYYY-MM-DD HH:mm:ss') : '-';
                }
                rowData[column.label] = value || '-';
              }
            });
            return rowData;
          });

          const worksheet = XLSX.utils.json_to_sheet(worksheetData);

          const colWidths = {};
          this.visibleColumns.forEach((column, index) => {
            const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
            colWidths[XLSX.utils.encode_col(index)] = { wch: width };
          });
          worksheet['!cols'] = Object.values(colWidths);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, '综合维保维修列表');

          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          const filename = `综合维保维修列表_${timestamp}.xlsx`;

          XLSX.writeFile(workbook, filename);
          this.$message.success('导出成功');
        }
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 改变每页条数后通常回到第一页
      this.fetchData(); // 确保调用时会使用最新的参数
    },
    handleCurrentChange(val) {
      this.currentPage = val; // 更新当前页码
      this.fetchData(); // 重新获取数据
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
    },

    // 根据上传内容返回显示文本
    getUploadDisplayValue(content) {
      if (!content) return '-';

      try {
        const parsedContent = JSON.parse(content);
        if (Array.isArray(parsedContent) && parsedContent.length > 0) {
          return `共${parsedContent.length}张图片`;
        }
      } catch (e) {
        // 如果解析失败，检查原始字符串长度
        if (typeof content === 'string' && content.length > 10) {
          return '查看详情';
        }
      }

      return content;
    },

    // 显示上传图片详情
    showUploadDetails(content, title) {
      if (!content) return; // 如果内容为空则不显示弹窗

      try {
        const parsedContent = JSON.parse(content);
        if (Array.isArray(parsedContent) && parsedContent.length > 0) {
          // 解析图片信息
          const fileList = [];
          parsedContent.forEach(item => {
            if (item.response && item.response.FileList && Array.isArray(item.response.FileList)) {
              item.response.FileList.forEach(fileInfo => {
                fileList.push({
                  name: fileInfo.name || '未知文件',
                  url: fileInfo.url || '',
                  status: fileInfo.status
                });
              });
            }
          });

          this.uploadDetailList = fileList;
          this.uploadDialogTitle = `${title} - 图片详情 (${fileList.length}张图片)`;
          this.uploadDetailDialogVisible = true;
        }
      } catch (e) {
        // 如果解析失败，显示原始内容
        console.error('解析上传内容失败:', e);
        this.uploadDetailList = [{
          name: '原始数据',
          url: content,
          status: 0
        }];
        this.uploadDialogTitle = `${title} - 原始内容`;
        this.uploadDetailDialogVisible = true;
      }
    },

    // 打开图片预览
    openImage(url) {
      window.open(url, '_blank');
    },

    // 复制到剪贴板
    copyToClipboard(text) {
      if (!text) return;

      navigator.clipboard.writeText(text).then(() => {
        this.$message.success('链接已复制到剪贴板');
      }).catch(err => {
        console.error('复制失败:', err);
        this.$message.error('复制失败，请手动复制');

        // 备用复制方法
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.custom-tabs {
  margin-bottom: 20px;
}

.analysis-container {
  min-height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.placeholder {
  color: #909399;
  font-size: 16px;
}

.container {
  padding: 20px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 13px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.box-card {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}

.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button+.el-button {
  margin-left: 8px;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}

::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}

::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}

/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: 100% !important;
}

::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}

::v-deep .el-tabs__nav-wrap::after {
  height: 1px !important;
}

/* 上传图片列样式 */
.upload-cell {
  cursor: pointer;

  &:hover {
    background-color: #f5f7fa;
    text-decoration: underline;
  }
}

.upload-detail-content {
  max-height: 500px;
  overflow-y: auto;

  .url-container {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .url-text {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 10px;
    }

    .copy-btn {
      flex-shrink: 0;
    }
  }

  .image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
  }
}
</style>